import React from 'react';
import './style.css';

const Divider = () => {
    return (
        <div class="astrodivider"><div class="astrodividermask"></div><span><i>&#10038;</i></span></div>
      );
}
 
export default Divider;